export const asosNamespace = "asos";
export const webRequestNamespace = "webRequest";
export const customerNamespace = "customer";
export const savedItemsSdkNamespace = "savedItemsSdk";
